export default __webpack_public_path__ + "static/media/7C4_at_2020-337-1.a5f6cd56.png";